import {
  AddShoppingCart,
  AttachMoney,
  Build,
  Group,
  Score,
  TrendingUp,
} from "@mui/icons-material";
import MuiPaper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CountUp } from "../../../components/CountUp";
import { Paper } from "../../../components/Paper";
import { Table } from "../../../components/Table";
import { IOverview } from "../../../types/results";
import { useStyles } from "../styles";
import { Funnel } from "../../../components/Recharts/Funnel";
import { isEmpty } from "lodash";
import WithoutInformation from "../../Home/WithoutInformation";
import { PaperChart } from "../../../components/PaperChart";
import { Bar } from "../../../components/Recharts/Bar";
import { Pie } from "../../../components/Recharts/Pie";
import { useCallback, useState } from "react";
import { DialogDetails } from "../../Results/DialogDetails";
import { DialogDetailClickRate } from "../DialogDetailClickRate";

type SendGroupProps = {
  loading?: boolean;
  campaign?: IOverview;
  rescue?: any[];
  rescueDetail?: any[];
  clickRate?: any[];
  day: any[];
  store: any[];
  hours: any[];
  genre: any[];
  ageGroup: any[];
  status: any[];
};

export function SendGroup({
  rescueDetail,
  clickRate,
  rescue,
  loading,
  campaign,
  day,
  ageGroup,
  genre,
  hours,
  store,
  status,
}: SendGroupProps) {
  const styles = useStyles();

  const [dialogDetails, setDialogDetails] = useState<boolean>(false);
  const [dialogDetailsClickRate, setDialogDetailsClickRate] =
    useState<boolean>(false);

  const handleDialogDetails = useCallback(() => {
    setDialogDetails((prev) => !prev);
  }, []);

  const handleDialogDetailsClickRate = useCallback(() => {
    setDialogDetailsClickRate((prev) => !prev);
  }, []);

  return (
    <>
      <Stack spacing={4}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Paper
            loading={loading}
            icon={<Group color="primary" fontSize="large" />}
            label="Alcance"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(campaign?.pessoas_alcancadas)}
          />
          <Paper
            loading={loading}
            icon={<Build color="primary" fontSize="large" />}
            label="Investimento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(campaign?.gastos_campanha)}
            prefix="R$"
            decimals={2}
          />
          <Paper
            loading={loading}
            icon={<Score color="primary" fontSize="large" />}
            label="Vendas"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(campaign?.qtde_vendas)}
          />
          <Paper
            loading={loading}
            icon={<AddShoppingCart color="primary" fontSize="large" />}
            label="Faturamento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={campaign?.valor_vendas ? Number(campaign?.valor_vendas) : 0}
            prefix="R$"
            decimals={2}
          />
          <Paper
            loading={loading}
            icon={<AttachMoney color="primary" fontSize="large" />}
            label="ROI"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(campaign?.valor_roi)}
            prefix="R$"
            decimals={2}
          />
          <Paper
            loading={loading}
            icon={<TrendingUp color="primary" fontSize="large" />}
            label="Margem"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(campaign?.margem_percentual)}
            suffix="%"
            decimals={2}
          />
        </Stack>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Button color="primary" variant="contained">
            Analítico
          </Button>
        </Stack>
        <Stack spacing={2} direction="row">
          <MuiPaper
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            <Stack spacing={2} direction="row" justifyContent="space-between">
              <Typography variant="h6" color="primary">
                Resgate de clientes
              </Typography>
              <Button variant="outlined" onClick={handleDialogDetails}>
                Ver detalhes
              </Button>
            </Stack>
            <Table
              isLoading={loading}
              toolbar={false}
              data={rescue}
              columns={[
                {
                  title: "Período sem compras",
                  field: "faixas",
                },
                {
                  title: "Clientes",
                  field: "total",
                  render: (row) => (
                    <CountUp end={Number(row?.total)} start={0} />
                  ),
                },
                {
                  title: "Valor em vendas",
                  field: "TOTAL",
                  render: (row) => (
                    <CountUp
                      end={Number(row?.VL_VENDAS)}
                      prefix="R$"
                      decimals={2}
                      start={0}
                    />
                  ),
                },
              ]}
              style={{ backgroundColor: "transparent" }}
              headerStyle={{ backgroundColor: "transparent" }}
              options={{
                actionsColumnIndex: -1,
                pageSize: 3,
                selectionProps: () => ({ color: "primary" }),
              }}
            />
          </MuiPaper>

          <MuiPaper
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            <Stack spacing={2} direction="row" justifyContent="space-between">
              <Typography variant="h6" color="primary">
                Taxa de cliques
              </Typography>
              <Button variant="outlined" onClick={handleDialogDetailsClickRate}>
                Ver detalhes
              </Button>
            </Stack>
            <Funnel data={clickRate} />
          </MuiPaper>
        </Stack>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Vendas por lojas"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(store) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="nome_loja"
                barDataKey="qtde_vendas"
                data={store}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
          <PaperChart
            loading={loading}
            label="Vendas por dias"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(day) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="DATA_ANALISE"
                barDataKey="qtde_vendas"
                data={day}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
        <PaperChart
          loading={loading}
          label="Vendas por hora"
          className={styles.paperCreatedDay}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(hours) ? (
            //@ts-ignore
            <Bar
              barLegend
              xDataKey="HORA_ANALISE"
              barDataKey="qtde_vendas"
              data={hours}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Gênero"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(genre) ? (
              <Pie nameKey="name" dataKey="value" data={genre} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>

          <PaperChart
            loading={loading}
            label="Faixa etária"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(ageGroup) ? (
              <Pie nameKey="name" dataKey="value" data={ageGroup} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
      </Stack>
      <DialogDetails
        data={rescueDetail}
        open={dialogDetails}
        onClose={handleDialogDetails}
      />
      <DialogDetailClickRate
        data={status}
        open={dialogDetailsClickRate}
        onClose={handleDialogDetailsClickRate}
      />
    </>
  );
}
